import { getFirestore } from 'firebase/firestore';
import { app } from './firebase'; // your existing firebase config

const db = getFirestore(app);

export { db };